import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from './FilterDefinition';
import { FilterOptionInformation } from '@studyportals/search-filters';
import { AttendanceFilterOptionValue } from '@studyportals/search-filters';

class AttendanceFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DELIVERY_METHOD,
			[
				new FilterOptionInformation('On Campus Learning', AttendanceFilterOptionValue.FACE_2_FACE, '', '', 'On Campus'),
				new FilterOptionInformation(
					'Online Learning',
					AttendanceFilterOptionValue.ONLINE,
					'online',
					'Online',
					'Online'
				),
				new FilterOptionInformation('Blended Learning', AttendanceFilterOptionValue.BLENDED, '', '', 'Blended')
			],
			[AttendanceFilterOptionValue.ONLINE]
		);
	}
}

export default new AttendanceFilterDefinition();
